module.exports = __webpack_public_path__ + "static/media/curve-4.99d4a796.svg";